import React, { useState } from "react";
import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
} from "@mui/material";
import LongTextComponent from "../Leads Page/LongTextComponent";
import moment from "moment";

function CompletedFollowupList({ completedFollowupData }) {
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [searchQuery, setSearchQuery] = useState(""); // Search query

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page
  };

  // Handle search query change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Filtered data based on search query
  const filteredData = completedFollowupData.filter((data) => {
    return (
      data.Lot_Number?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      data.Farmer_Name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      data.Branch_Name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      data.Zone_Name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      data.agent_name?.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  // Get paginated data
  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Paper>
      {/* Search Bar */}
      <TextField
        label="Search"
        variant="outlined"
        size="small"
        sx={{ marginBottom: 2, margin: 1, float: 'right' }}
        value={searchQuery}
        onChange={handleSearchChange}
      />
      
      <TableContainer
        sx={{
          boxShadow: 2,
          borderRadius: "8px",
          margin: "16px 0",
        }}
      >
        <Table
          sx={{ minWidth: 650, height: "100%", tableLayout: "fixed" }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
              <TableCell align="center" sx={{ width: 50 }}>
                Sno
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Lot Number
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Farmer Name
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Branch Name
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Zone Name
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Last Action Date
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Follow-up Date
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Agent Name
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(paginatedData) && paginatedData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9}>No Data Available Yet.</TableCell>
              </TableRow>
            ) : (
              paginatedData?.map((data, index) => (
                <TableRow key={data?.id || index}>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {page * rowsPerPage + index + 1}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.Lot_Number || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.Farmer_Name || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.Branch_Name || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.Zone_Name || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {moment(data?.completed_on).format("DD-MM-YYYY") || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {moment(data?.follow_up_date).format("DD-MM-YYYY") || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.agent_name || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    <Chip
                      label={data?.follow_up_status}
                      color={"success"}
                      size="small"
                      sx={{ textTransform: "capitalize", margin: "5px" }}
                    />
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={Array.isArray(paginatedData) ? paginatedData.length : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

export default CompletedFollowupList;
